<div class="carousel-container col-9 col-lg-12 px-0">
  <div [ngClass]="darkTheme ? 'dark-carousel-inner' : 'carousel-inner'" class="mx-auto d-flex flex-column shadow">
    <img src="{{userComment.image}}" class="d-block carousel-image mx-auto" alt="..." loading="lazy">
    <p class="px-1 yellow-text text-center mt-3 mb-0">- {{userComment.userName}}</p>
    <div class="flex-grow-1 d-flex align-items-center">
      <p class="px-2 text-center pb-2 my-auto mt-0"><span class="large-quote">" </span>{{userComment.comment}}<span class="large-quote">&nbsp;"</span></p>
    </div>
  </div>
</div>
